export const PHONE_MASK = isDevEnv() ? '+\\9\\96 (999) 999999' : '+7 (999) 999 99 99'
export const PHONE_EMPTY_REGEX = isDevEnv() ? /^\+996 \(___\) ______$/ : /^\+7 \(___\) ___ __ __$/;
export const PHONE_CORRECT_REGEX = isDevEnv() ? /^\+996 \(\d{3}\) \d{6}$/ : /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;

function isDevEnv() {
    return process.env.NODE_ENV === 'development';
}


// WEBPACK FOOTER //
// ./src/constants/formats.js